  <div class="wrapper">
    <div class="map_frame">
      <ng-content select="[map]"></ng-content>
    </div>
    <div class="text_frame">
      <ng-content select="[contact]"></ng-content>
    </div>
  </div>
